import Render from '@Views/root/help/aside-support.html'
import { Component, Vue, Watch } from 'vue-property-decorator'



@Render
@Component({})
export class ASideSupport extends Vue {

	helpHome() {
		this.$router.push({name: 'help'})
	}
	howItWorks() {
		this.$router.push({name: 'how-it-works'})
	}
}
